<template>
  <form @submit.prevent="onSearch">
    <div class="row mb-2">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div v-if="officeDropdown && officeDropdown.length">
          <SelectVue
              v-model="filters.officeId"
              :options="officeDropdown"
              :is-clear="true"
              :placeholder="$t('placeholder.office_name')"
          />
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <div v-if="federalStatesDropdown && federalStatesDropdown.length">
          <SelectVue
              v-model="filters.federalState"
              :options="federalStatesDropdown"
              :is-clear="true"
              :placeholder="$t('placeholder.select_federal_state')"
          />
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <div v-if="officeTypesDropdown && officeTypesDropdown.length">
          <SelectVue
              v-model="filters.type"
              :options="officeTypesDropdown"
              :is-clear="true"
              :placeholder="$t('placeholder.type')"
          />
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <div v-if="officeEngagementTypesDropdown && officeEngagementTypesDropdown.length">
          <SelectVue
              v-model="filters.engagementType"
              :options="officeEngagementTypesDropdown"
              :is-clear="true"
              :placeholder="$t('placeholder.engagement_type')"
          />
        </div>
      </div>
      <div v-if="officeStatusesDropdown && officeStatusesDropdown.length" class="col-lg-2 col-md-6 col-sm-12">
        <SelectVue
            v-model="filters.status"
            :options="officeStatusesDropdown"
            :is-clear="true"
            placeholder="Status"
        />
      </div>
      <div class="col-lg-1 col-sm-12 col-12 d-flex d-lg-block justify-content-center">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import SelectVue from '@/components/SelectVue.vue';
import {defineEmits, defineProps, toRef} from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  officeDropdown: {
    type: Array,
    required: true,
  },
  federalStatesDropdown: {
    type: Array,
    required: true,
  },
  officeTypesDropdown: {
    type: Array,
    required: true,
  },
  officeEngagementTypesDropdown: {
    type: Array,
    required: true,
  },
  officeStatusesDropdown: {
    type: Array,
    default: () => [],
  },
});

// Emit search event
const emit = defineEmits(['search']);

// Use toRefs to maintain reactivity
const filters = toRef(props, 'filters');
const officeDropdown = toRef(props, 'officeDropdown');
const federalStatesDropdown = toRef(props, 'federalStatesDropdown');
const officeTypesDropdown = toRef(props, 'officeTypesDropdown');
const officeEngagementTypesDropdown = toRef(props, 'officeEngagementTypesDropdown');
const officeStatusesDropdown = toRef(props, 'officeStatusesDropdown');

function onSearch() {
  emit('search', 1, undefined, filters.value);
}

</script>

<style scoped>
</style>
